module.exports = __webpack_public_path__ + "static/cabina-de-conductor---cupula-7de916efeda1f6d1ff21d8feb790ece3.jpg";